'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ChromeVisibilityContext, getChromeSpringConfig, } from '#pplx/frontend/apps/ask/layout/primitives/ChromeVisibilityProviderShared.js';
import { useControllableState } from '#pplx/frontend/common/hooks/useControllableState.js';
import { useReducedMotion } from '#pplx/frontend/common/hooks/useReducedMotion.js';
import { useSpring } from '@react-spring/web';
import React, { useMemo } from 'react';
export const ChromeVisibilityProvider = ({ children, visible: controlledVisible, onVisibleChange, }) => {
    const [visible, setVisible] = useControllableState({
        value: controlledVisible,
        defaultValue: true,
        onChange: onVisibleChange,
    });
    const reducedMotion = useReducedMotion();
    const { progress } = useSpring({
        progress: visible ? 1 : 0,
        config: getChromeSpringConfig(visible),
        immediate: reducedMotion,
    });
    const value = useMemo(() => ({ visible, setVisible, spring: progress }), [progress, setVisible, visible]);
    return (_jsx(ChromeVisibilityContext.Provider, { value: value, children: children }));
};
//# sourceMappingURL=ChromeVisibilityProvider.js.map